import React from "react";
import { FaLinkedinIn } from "react-icons/fa";

let data = [
  {
    images:
      "/assets/images/team/tushar_nikam.jpeg",
    title: "Tushar Nikam",
    designation: "Senior Full Stack Developer",
    techStack: "(Node.js)",

    socialNetwork: [
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/tushar-nikam-a3a56174",
      },
    ],
  },
  // {
  //   images:
  //     "/assets/images/team/mohnish_mahakalkar.jpeg",
  //   title: "Mohnish Mahakalkar",
  //   designation: "Full Stack Developer",
  //   techStack: "(Node.js)",

  //   socialNetwork: [
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "https://www.linkedin.com/in/mohnishmahakalkar",
  //     },
  //   ],
  // },
  // {
  //   images:
  //     "/assets/images/team/himanshu_supare.jpeg",
  //   title: "Himanshu Supare",
  //   designation: "Backend Developer",
  //   techStack: "(Node.js)",

  //   socialNetwork: [
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "https://www.linkedin.com/in/himanshusupare",
  //     },
  //   ],
  // },
  {
    images:
      "/assets/images/team/abhinandan_bhope.jpeg",
    title: "Abhinandan Bhope",
    designation: "Backend Developer",
    techStack: "(Node.js)",
    socialNetwork: [
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/abhinandan-bhope-523082203",
      },
    ],
  },
  {
    images:
      "/assets/images/team/dilip.png",
    title: "Dilip Lovevanshi",
    designation: "Frontend Developer",
    techStack: "(React/React Native)",
    socialNetwork: [
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/dilip884400/",
      },
    ],
  },
  {
    images:
      "/assets/images/team/pratik.png",
    title: "Pratik Sondaule ",
    designation: "Backend Developer",
    techStack: "(Node.js)",
    socialNetwork: [
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/pratik-sondaule-aa34b31b8/",
      },
    ],
  },
   {
    images:
      "/assets/images/team/shubham.png",
    title: "Bhushan Zombade",
    designation: "Frontend Developer",
    techStack: "(React.js)",

    socialNetwork: [
      {
        icon: <FaLinkedinIn />,
        url: "https://www.linkedin.com/in/shubham-sonawane-77b749192/",
      },
    ],
  },

  
  //   {
  //     images: "05",
  //     title: "Fatima Asrafi",
  //     designation: "Front-end Engineer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //     ],
  //   },
  //   {
  //     images: "06",
  //     title: "Fatima Amar",
  //     designation: "Sr. Graphic Designer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaTwitter />,
  //         url: "#",
  //       },
  //     ],
  //   },
  //   {
  //     images: "07",
  //     title: "Fatima Amar",
  //     designation: "Sr. Graphic Designer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaTwitter />,
  //         url: "#",
  //       },
  //     ],
  //   },
  //   {
  //     images: "11",
  //     title: "John Dou",
  //     designation: "Sr. Graphic Designer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaTwitter />,
  //         url: "#",
  //       },
  //     ],
  //   },
  //   {
  //     images: "09",
  //     title: "John Dou",
  //     designation: "Sr. Graphic Designer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaTwitter />,
  //         url: "#",
  //       },
  //     ],
  //   },
  //   {
  //     images: "11",
  //     title: "John Dou",
  //     designation: "Sr. Graphic Designer",
  //     socialNetwork: [
  //       {
  //         icon: <FaFacebookF />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaLinkedinIn />,
  //         url: "#",
  //       },
  //       {
  //         icon: <FaTwitter />,
  //         url: "#",
  //       },
  //     ],
  //   },
];

export default data;
